import React from 'react';

import Photo from "../../../atoms/photo";
import IconButton from "../../../atoms/icon-button";
import CustomerCard from "../../customer/customer-card";
import Grid from "../../grid";
import Window from "../../window";
import StatusLabel from "../../../atoms/status-label";

class CartListItem extends React.Component {
    
    static defaultProps = {
        model: {},
        footer: null,
        onDelete: () => {
        }
    };
    
    getHeader() {
        if (this.props.model.order) {
            return null;
        }
        
        return (
            <IconButton modifiers={'alt'} iconType={'delete'} onClick={e => this.props.onDelete(this.props.model)}/>
        );
    }
    
    getContents() {
        return (
            <Grid cols={'repeat(5, 1fr)'} modifiers={'padded-alternate-direction'}>
                {this.props.model.items ? this.props.model.items.map((item, i) => {
                    return (
                        <Photo key={i} src={item.buyable.thumbnail_url} modifiers={'round'}/>
                    );
                }).reverse() : null}
            </Grid>
        );
    }
    
    getFooter() {
        if (this.props.model.order_fully_paid) {
            return (
                <StatusLabel modifiers={['success', 'compact']} title={"Fully Paid"}/>
            );
        }
        
        if (this.props.model.has_pending_transactions) {
            return (
                <StatusLabel modifiers={['error', 'compact']} title={"Pending Payments"}/>
            );
        }
        
        if (this.props.model.has_completed_transactions) {
            return (
                <StatusLabel modifiers={['error', 'compact']} title={"Partially Paid"}/>
            );
        }
        
        if (this.props.model.order) {
            return (
                <StatusLabel modifiers={['warning', 'compact']} title={"Order Created"}/>
            );
        }
        
        return null;
    }
    
    render() {
        return (
            <Window
                title={'Cart #' + this.props.model.id + ' (€ ' + this.props.model.total.toFixed(2) + ')'}
                modifiers={['padded', 'frame']}
                header={this.getHeader()}
                footer={this.getFooter()}
            >
                {this.props.model.customer ? <CustomerCard showAddress={false} customer={this.props.model.customer}/> : ''}
                {this.getContents()}
            </Window>
        );
    }
}

export default CartListItem;